import { Link } from "react-router-dom";
import { ArrowRight, UserCog } from "lucide-react";
import { Reveal } from "@/components/motion";

export const FractionalBanner = ({ className = "" }) => (
  <Reveal className={className}>
    <div className="bg-[#FACC15] text-black p-8 sm:p-10 flex flex-col lg:flex-row lg:items-center gap-8" data-testid="fractional-banner">
      <div className="w-14 h-14 shrink-0 bg-black text-[#FACC15] flex items-center justify-center">
        <UserCog size={26} strokeWidth={1.8} />
      </div>
      <div className="flex-1">
        <p className="eyebrow-dark mb-3">Fractional management · in evidenza</p>
        <h3 className="text-2xl sm:text-3xl font-bold leading-tight" style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}>
          Non hai chi ti segue? Ti affidiamo un manager per tutto il tempo del progetto.
        </h3>
        <p className="mt-3 text-black/70 text-base leading-relaxed max-w-2xl">
          Un manager Idea 360 entra in azienda, part-time o a progetto, e guida l'area che oggi nessuno presidia: finanza, marketing, persone, operations. Con obiettivi e KPI condivisi.
        </p>
      </div>
      <Link
        to="/contatti?service=Fractional%20Management"
        className="btn-black inline-flex items-center gap-2 self-start lg:self-center group shrink-0"
        data-testid="fractional-banner-cta"
      >
        Richiedi informazioni
        <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
      </Link>
    </div>
  </Reveal>
);

export default FractionalBanner;
